function getProducts(items) {
    var products = [];
    for(var item of items) {
        var product = $.ajax({dataType: "json", url: '/products/' + item.handle + '.js', async: false}).responseJSON;
        if (product) products.push(product);
    }
    return products;
}

function filterReservationProducts(products) {
    var results = [];
    for (var product of products) {
        if (isReservationProduct(product)) results.push(product);
    }
    return results;
}

function isReservationProduct(product) {
    var result = false;
    for(var tag of product['tags']) {
        if (tag === '予約商品') {
            result = true;
            break;
        }
    }
    return result;
}

$(document).ready(function(){

    var reservation = $('#reservation').text() === 'true';

    $('#customButton').click(function() {
        var cartItems = $.ajax({dataType: "json", url: '/cart.js', async: false}).responseJSON.items;

        var result = false;
        if (cartItems) {
            var products = getProducts(cartItems);
            var reservationProducts = filterReservationProducts(products);
            var inReserved = reservationProducts.length > 0 //trueなら予約商品を含んでいる

            if (reservation === inReserved || products.length == 0) {
                result = true;
            } else {
                alert("予約商品と通常商品を同時にカートに入れることは出来ません");
                result = false;
            }
        }

        return result;
    });
});

/** 常設カートに入れるボタン 表示管理 */
var $variantListBg;
function getVariantListBg() {
    if($variantListBg === undefined) {
        var $variantListBg = $('#variantListBg');
    }
    return $variantListBg;
}

var $variantList;
function getVariantList() {
    if($variantList === undefined) {
        var $variantList = $('#variantList');
    }
    return $variantList;
}

function openVariants() {
    getVariantListBg().show();
    getVariantList().slideToggle();
}

function closeVariants() {
    getVariantListBg().hide();
    getVariantList().slideToggle();
}